(() => {
  if (window.ykGroupDropdowns) return;
  window.ykGroupDropdowns = true;
  const entries = new Map();
  const initialize = () => {
    document.querySelectorAll('yk-featured-products select, yk-popular-clicks select[data-sort]').forEach(select => {
      if (select.dataset.popoverReady) return;
      select.dataset.popoverReady = 'true';
      const host = select.parentElement;
      const label = host.querySelector('label');
      const title = select.hasAttribute('data-sort') ? 'Sort by' : 'Subject';
      const id = `${select.id}-popover`;
      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'collection-toolbar__button heading text-xxs w-full';
      trigger.setAttribute('aria-controls', id);
      trigger.setAttribute('aria-expanded', 'false');
      trigger.dataset.groupDropdown = id;
      trigger.innerHTML = `<span class="text-with-icon justify-center">${title}<svg aria-hidden="true" focusable="false" fill="none" width="10" viewBox="0 0 10 10"><path d="m1 3 4 4 4-4" stroke="currentColor" stroke-linecap="square"/></svg></span>`;
      const popover = document.createElement('x-popover');
      popover.id = id;
      popover.className = 'popover popover--bottom-end color-scheme color-scheme--dialog yk-group-dropdown-popover';
      popover.setAttribute('close-on-listbox-select', '');
      const heading = document.createElement('p');
      heading.className = 'h4'; heading.slot = 'header'; heading.textContent = title;
      popover.append(heading);
      let list;
      const build = () => {
        const next = document.createElement('x-listbox');
        next.className = 'popover__value-list';
        next.setAttribute('aria-label', title);
        [...select.options].forEach(option => {
          const button = document.createElement('button');
          button.type = 'button'; button.className = 'popover__value-option group';
          button.setAttribute('role', 'option'); button.value = option.value;
          button.setAttribute('aria-selected', String(option.value === select.value));
          button.disabled = option.disabled;
          const span = document.createElement('span'); span.className = 'reversed-link'; span.textContent = option.text;
          button.append(span); next.append(button);
        });
        if (list) list.replaceWith(next); else popover.append(next);
        list = next;
      };
      build();
      popover.addEventListener('listbox:change', event => {
        if (select.value === event.detail.value) return;
        select.value = event.detail.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
      select.addEventListener('change', () => {
        const option = [...list.querySelectorAll('[role=option]')].find(option => option.value === select.value);
        if (option?.id) list.setAttribute('aria-activedescendant', option.id);
      });
      new MutationObserver(build).observe(select, { childList: true, subtree: true });
      entries.set(id, { popover, select });
      host.classList.add('yk-group-dropdown', 'collection-toolbar__button-container');
      if (label) label.hidden = true;
      select.hidden = true;
      host.append(trigger, popover);
    });
  };
  window.addEventListener('click', event => {
    const trigger = event.target.closest('[data-group-dropdown]');
    if (trigger) {
      const entry = entries.get(trigger.dataset.groupDropdown);
      if (!entry) return;
      event.preventDefault(); event.stopImmediatePropagation();
      entry.popover.open ? entry.popover.hide() : entry.popover.show();
      return;
    }
    const option = event.target.closest('.yk-group-dropdown-popover [role=option]');
    if (!option) return;
    const popover = option.closest('.yk-group-dropdown-popover');
    if (!entries.has(popover.id)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    option.closest('x-listbox').setAttribute('aria-activedescendant', option.id);
    option.dispatchEvent(new CustomEvent('listbox:select', { bubbles: true, detail: { value: option.value } }));
  }, true);
  Promise.all([customElements.whenDefined('x-popover'), customElements.whenDefined('x-listbox')]).then(() => {
    initialize();
    document.addEventListener('shopify:section:load', initialize);
  });
})();
